import axios from "axios";
import { API_URL, getHeader } from "../config";

export const getHighlight = async () => {
  const { data } = await axios.get(API_URL + `/api/highlight/SJSKBUP`);
  console.log(data);
  return data;
};

export const getNews = async () => {
  console.log("first");
  const { data } = await axios.get(API_URL + `/api/news/SJSKBUP`);
  console.log("news:", data);
  return data;
};
export const getNewsInner = async () => {
  console.log("first");
  const { data } = await axios.get(API_URL + `/api/news/all/SJSKBUP`);
  console.log("news:", data);
  return data;
};

export const getEvents = async () => {
  const { data } = await axios.get(API_URL + `/api/events/SJSKBUP`);
  console.log(data);
  return data;
};

export const getEventsinner = async () => {
  const { data } = await axios.get(API_URL + `/api/events/All/SJSKBUP`);
  console.log(data);
  return data;
};

export const getGallery = async () => {
  const { data } = await axios.get(API_URL + `/api/gallery/SJSKBUP`);
  return data;
};

export const getGalleryInner = async () => {
  const { data } = await axios.get(API_URL + `/api/gallery/All/SJSKBUP`);
  return data;
};

export const getSubGallery = async (id) => {
  console.log(id);
  const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`);
  console.log(data);
  return data;
};

export const getNotification = async () => {
  const { data } = await axios.get(
    API_URL + `/api/notification/SJSKBUP`,
    getHeader()
  );
  console.log("popup", data);
  return data;
};

export const getTopper = async () => {
  const { data } = await axios.get(API_URL + `/api/topper/SJSKBUP`, getHeader());
  return data;
};

export const getOnlineRegistration = async () => {
  const { data } = await axios.get(
    API_URL + `/api/onlineRegistration/SJSKBUP`,
    getHeader()
  );
  console.log("online registration Data", data);
  return data;
};

export const getPrincipalMessage = async () => {
  const { data } = await axios.get(
    API_URL + `/api/principalMessage/SJSKBUP`,
    getHeader()
  );
  return data;
};

export const getVideo = async () => {
  const { data } = await axios.get(API_URL + `/api/video/All/SJSKBUP`);
  return data;
};
export const postTransferCertificate = async (name, admission) => {
  console.log(name, admission);

  const { data } = await axios.post(
    API_URL + `/api/tc/SJSKBUP`,
    { name, admission },
    getHeader()
  );
  return data;
};

export const form1 = async (formData, header, type) => {
  try {
    const { data } = await axios.post(
      `${API_URL}/api/form/SJSKBUP/${type}`,
      formData,
      header
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error in form submission:", error);
    if (error.response) {
      console.error("Error response data:", error.response.data);
    }
    throw error;
  }
};
export const academicCalender = async () => {
  const { data } = await axios.get(
    API_URL + `/api/academicCalender/all/SJSKBUP`,
    getHeader()
  );
  console.log("academic calender", data);
  return data;
};
